module.exports = __webpack_public_path__ + "static/img/24.119b8a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/hotKeywordsMap/map/24.png
// module id = L5de
// module chunks = 2